import { Injectable, inject } from '@angular/core'
import { Actions, createEffect } from '@ngrx/effects'
import { map, switchMap, withLatestFrom } from 'rxjs/operators'
import { onCreate } from '../../../shared/utils/redux/operators'
import { AsyncTasksActions } from './async-task.actions'
import { AsyncTasksService } from '../../../shared/remote-services/async-tasks.service'
import { forkJoin, merge, of } from 'rxjs'
import { JobsiteSummaryActions } from '../../../jobsites-management/jobsite-summary/store/jobsite-summary.actions'
import { State } from '../state'
import { Store } from '@ngrx/store'
import { getJobsiteId, getTechnique } from '../router/router.selectors'
import { getUserId } from '../user'

@Injectable()
export class AsyncTasksEffects {
  private readonly actions$ = inject(Actions)
  private readonly store = inject<Store<State>>(Store)
  private readonly asyncTasksService = inject(AsyncTasksService)

  handleEvent$ = createEffect(() =>
    this.actions$.pipe(
      onCreate(AsyncTasksActions.ackAsyncTasks),
      map(a => a.payload),
      switchMap(task =>
        forkJoin([of(task), this.asyncTasksService.ack(task.id)]),
      ),
      map(([task]) =>
        AsyncTasksActions.setAsyncTasks.createRemoveItems([task]),
      ),
    ),
  )

  preCreateAsyncTaskInStore = createEffect(() =>
    merge(
      this.actions$.pipe(onCreate(JobsiteSummaryActions.importCSVColumns)),
      this.actions$.pipe(onCreate(JobsiteSummaryActions.updateMultiColumns)),
    ).pipe(
      map(a => a.payload),
      withLatestFrom(
        this.store.select(getTechnique),
        this.store.select(getJobsiteId),
        this.store.select(getUserId),
      ),
      map(([_, technique, jobsiteId, userId]) =>
        AsyncTasksActions.setAsyncTasks.createAddItem({
          id: '',
          jobsiteId: jobsiteId,
          progress: null,
          status: 'RUNNING',
          technique: technique,
          type: 'LAYOUT_UPDATE',
          userId: userId,
        }),
      ),
    ),
  )
}
